const en = {
    Common: {
        ALL: "All",
        ADD_NEW: "Create",
        GO_BACK: "Back",
        EDIT: "Edit",
        SAVE: "Save",
        VIEW_DETAIL: "View detail",
        DELETE: "Delete",
        CANCEL: "Cancel",
        REQUIRED: "Required data field",
        REQUIRED_SERVICE_CODE: "Service code required",
        PLEASE_COMPLETE_ALL_INFORMATION: "Please fill in all required information",
        ERROR: "An error occurred during processing, please try again later. Sorry for causing inconvenience.",
        CANCEL_ACTION_MESSAGE: "The unsaved changes will be lost. Are you sure you want to leave the current screen?",
        EMAIL: "Email",
        SMS: "Sms",
        NOTIFICATION: "Notification",
        SEARCH_TEXT: "Search",
        ENTER_SEARCH_TEXT: "Enter keywords to search",
        UNREAD: "Unread",
        MARK_READ_ALL: "Mark read all",
        NO_DATA: "No data",
        NO_DATA_NOTIFI: "No data notification",
        LOADING: "Loading datas",
        NO: "No",
        YES: "Yes",
        DENIED_PERMISSION_NOTIFI: "You have not granted notification permission to this app",
        PLEASE_SEE: "Please see",
        HERE: "here",
        BLOCK: "Block",
        REMOVE: "Remove",
        REPLACE: "Replace",
        UPLOAD: "Upload",
        CONTINUE: "Continue",
        PAUSE: "Pause",
        RECOMMENDED_FORMAT: "Recommended format: {0} x {1} pixels (PNG or JPG)",
        UPLOAD_YOUR: "Upload your",
        PUBLISH: "Publish",
        STOP_PUBLISH: "Stop publish",
        UNPUBLISHING: "Unpublishing",
        UNPUBLISHED: "Unpublished",
        PUBLISH_READY: "Publish ready",
        NOT_PUBLISH_READY: "Not publish ready",
        PUBLISHING: "Publishing",
        PUBLISHED: "Published",
        UNKNOWN: "Unknown",
        Public: "Public",
        Private: "Private",
        STATUS: "Status",
        CLOSE: "Close",
        INVITE: "Invite",
        REJECT: "Reject",
        JOIN: "Join",
    },

    SETTING_FIREBASE: {
        BASIC_INFO: "Setting code information",

        ADMIN_SDK: "Admin SDK",
        VAPID_KEY: "Vapid Key",
        CLIENT_CONFIG: "Client Config",
        SERVICE_NAME: "Service name",
        SELECT_SERVICE: "Select service",
        ENTER_ADMIN_SDK: "Enter Admin SDK",
        ENTER_VAPID_KEY: "Enter Vapid Key",
        ENTER_CLIENT_CONFIG: "Enter Client Config",
        UPDATE_SUCCESS: "Firebare config information updated successfully",
    },

    MESSAGE_TEMPLATE: {
        TITLE_MENU: "Message template",
        TITLE_LIST_VIEW: "List of message template",
        TITLE_UPDATE_VIEW: "Update message template information",
        TITLE_DETAIL_VIEW: "Message template information detail",
        TITLE_CREATE_VIEW: "Add new message template",
        BASIC_INFO: "Message template information",

        NAME: "Name",
        TITLE: "Title",
        CC: "CC",
        BCC: "BCC",
        FROM: "From",
        TO: "to",
        TYPE: "Type",
        CONTENT: "Content",
        INPUT_NAME: "Input name",
        INPUT_TITLE: "Input title",
        INPUT_CC: "Input CC",
        INPUT_BCC: "Input BCC",
        INPUT_FROM: "Input from",
        INPUT_TO: "Input to",
        SELECT_TYPE: "Select type",
        INPUT_CONTENT: "Input content",

        KEYWORD_LIST: "List of keyword",
        KEYWORD: "Keyword",
        VALUE: "Value",
        INPUT_KEYWORD: "Input keyword",
        INPUT_VALUE: "Input value",

        TENANT: "Tenant",
        SERVICE: "Service",
        ORGANIZATION: "Organization",
        SELECT_TENANT: "Select tenant",
        SELECT_SERVICE: "Select service",
        SELECT_ORGANIZATION: "Select organization",

        CONFIRM_DELETE: "Bạn chắc chắn muốn xóa mẫu thông báo này?",
        DELETE_SUCCESS: "Xóa mẫu thông báo thành công",
        CREATE_SUCCESS: "Tạo mới mẫu thông báo thành công",
        UPDATE_SUCCESS: "Cập nhật thông tin mẫu thông báo thành công",
    },

    MESSAGE_TEMPLATE_CASE: {
        TITLE_MENU: "Message template case",
        TITLE_LIST_VIEW: "List of message template case",
        TITLE_UPDATE_VIEW: "Update message template case information",
        TITLE_DETAIL_VIEW: "Message template case information detail",
        TITLE_CREATE_VIEW: "Add new message template case",
        BASIC_INFO: "Message template case information",

        MESSAGE_TEMPLATE: "Message template",
        SELECT_MESSAGE_TEMPLATE: "Select message template",
        CASE: "Case",
        SELECT_CASE: "Select case",
        NAME: "Name",
        TITLE: "Title",
        CC: "CC",
        BCC: "BCC",
        FROM: "From",
        TO: "to",
        TYPE: "Type",
        CONTENT: "Content",
        INPUT_NAME: "Input name",
        INPUT_TITLE: "Input title",
        INPUT_CC: "Input CC",
        INPUT_BCC: "Input BCC",
        INPUT_FROM: "Input from",
        INPUT_TO: "Input to",
        SELECT_TYPE: "Select type",
        INPUT_CONTENT: "Input content",

        KEYWORD_LIST: "List of keyword",
        KEYWORD: "Keyword",
        VALUE: "Value",
        INPUT_KEYWORD: "Input keyword",
        INPUT_VALUE: "Input value",

        TENANT: "Tenant",
        SERVICE: "Service",
        ORGANIZATION: "Organization",
        SELECT_TENANT: "Select tenant",
        SELECT_SERVICE: "Select service",
        SELECT_ORGANIZATION: "Select organization",
        CONFIRM_DELETE: "Bạn chắc chắn muốn xóa hộp mẫu thông báo này?",
        DELETE_SUCCESS: "Xóa hộp mẫu thông báo thành công",
        CREATE_SUCCESS: "Tạo mới hộp mẫu thông báo thành công",
        UPDATE_SUCCESS: "Cập nhật thông tin của hộp mẫu thông báo thành công",
    },

    MESSAGE: {
        ERROR: "Đã có phát sinh lỗi trong quá trình xử lý, vui lòng thử lại sau. Xin lỗi vì đã gây bất tiện.",
        SUCCESS: "Thành công",
        PLACEHOLDER: "Chọn...",
        CONFIRM_LOGOUT: "Bạn có muốn đăng xuất?",
        CONFIRM_CREATE: "Bạn có chắc muốn tạo?",
        CONFIRM_UPDATE: "Bạn có chắc muốn cập nhật?",
        CONFIRM_DELETE: "Bạn có thực sự muốn xóa?",
        CONFIRM_DELETE_ALL: "Bạn có thực sự muốn xóa tất cả?",
        CONFIRM_BLOCK: "Bạn có thực sự muốn khoá tài khoản?",
        CONFIRM_SUBMIT: "Bạn có thực sự muốn gửi?",
        CONFIRM_CANCEL: "Bạn có thực sự muốn hủy?",
        CONFIRM_CANCEL_ACTIVE: "Bạn có thực sự muốn hủy kích hoạt?",
        CONFIRM_EXPORT_FILE: "Bạn có thực sự muốn tải tệp?",
        CONFIRM_APPROVE: "Bạn có thực sự muốn phê duyệt?",
        CONFIRM_REJECT: "Bạn có thực sự muốn từ chối?",
        CREATE_SUCCESS: "Tạo thành công",
        UPDATE_SUCCESS: "Cập nhật thành công",
        PAYMENT_SUCCESS: "Thanh toán thành công",
        UPDATE_STATUS_SUCCESS: "Cập nhật trạng thái thành công",
        EXPORT_FILE_SUCCESS: "Tải tệp thành công",
        DELETE_SUCCESS: "Xóa thành công",
        DELETE_ALL_SUCCESS: "Xóa tất cả thành công",
        BLOCK_SUCCESS: "Khoá thành công",
        CANCEL_SUCCESS: "Hủy thành công",
        APPROVE_SUCCESS: "Phê duyệt thành công",
        REJECT_SUCCESS: "Từ chối thành công",
        LOGIN_SUCCESS: "Đăng nhập thành công",
        LOGOUT_SUCCESS: "Đăng xuất thành công",
        CREATE_ERROR: "Tạo không thành công",
        BLOCK_ERROR: "Khoá không thành công",
        UPDATE_ERROR: "Cập nhật không thành công",
        EXPORT_FILE_ERROR: "Tải tệp không thành công",
        CANCEL_ERROR: "Hủy không thành công",
        APPROVE_ERROR: "Phê duyệt không thành công",
        REJECT_ERROR: "Từ chối không thành công",
        DELETE_ERROR: "Xóa không thành công",
        DELETE_ALL_ERROR: "Xóa tất cả không thành công",
        LOGIN_ERROR: "Đăng nhật không thành công",
        LOGOUT_ERROR: "Đăng xuất không thành công",
        EPR_TOKEN: "Phiên đăng nhập đã hết hạn!",
        PASSWORD_ERROR: "Tài khoản hoặc mật khẩu không đúng.",
        CREATE_USER_SUCCESS: "Thêm mới nhân viên thành công",
        PLEASE_COMPLETE_ALL_INFORMATION: "Vui lòng điền đầy đủ thông tin yêu cầu",
        INVALID_EMAIL: "Email không hợp lệ",
        INVALID_PHONENUMBER: "Số điện thoại không hợp lệ",
        CONFIRM_CHANGE_STATUS: "Bạn có chắc chắn muốn thay đổi trạng thái?",
        CHANGE_PHONE_NUMBER_SUCCESS: "Thay đổi số điện thoại thành công",
        CHANGE_PASSWORD_SUCCESS: "Thay đổi mật khẩu thành công",
        CHANGE_PROFILE_SUCCESS: "Thay đổi thông tin cá nhân thành công",
        NO_FUNCTION: "Xin lỗi! Hiện chưa có chức năng này!",
        CANCEL_ACTION_MESSAGE: "Thông tin chỉnh sửa chưa được lưu. Bạn chắc chắn muốn rời khỏi màn hình hiện tại không?",
        TOKEN_EXPIRED: "Hết hạn cho phiên đăng nhập! Vui lòng đăng nhập lại",
        USER_PROFILE_NOT_FOUND: "Không tìm thấy thông tin người dùng, vui lòng đăng nhập lại!",
        CONFIRM_EXPORT: "Bạn có muốn xuất file excel?",
        NOT_FORMAT_IMG: "Không đúng định dạng hình ảnh cho phép! (.png |.gif | .jpeg)",
        LIMIT_NUMBER_OF_PHOTO: "Giới hạn thêm tối thiểu là {0} ảnh và tối đa chỉ {1} ảnh",
        LIMIT_SIZE_OF_IMG: "Kích thước file lớn hơn {0}MB",
        NOT_FOUND: "Không tìm thấy dữ liệu!",
        NOT_PERMISSION: "Rất tiếc, bạn không có quyền truy cập",
        NO_ROLE_UPDATE: "Bạn không có quyền cập nhật",
        NO_ROLE_DELETE: "Bạn không có quyền xóa",
        GROUP_ALREADY_EXIST: "Nhóm đã tồn tại",
        PLEASE_ADD_PERMISSION: "Vui lòng thêm nhóm quyền",
        PLEASE_ADD_GROUP_WORK: "Vui lòng thêm nhóm làm việc",
        DONT_HAVE_ORGANIZATION: "Để sử dụng chức năng này vui lòng tạo hoặc ",
        CORRESPONDING_ORGANIZATION: " tổ chức tương ứng.",
        CONFIRM_ACTIVE_STATUS: "Bạn chắc chắn muốn chuyển sang trạng thái kích hoạt?",
        CONFIRM_IN_ACTIVE_STATUS: "Bạn chắc chắn muốn chuyển sang trạng thái hủy kích hoạt?",
        IN_ACTIVE_STATUS_SUCCESS: "Cập nhật trạng thái sang hủy kích hoạt thành công",
        ACTIVE_STATUS_SUCCESS: "Cập nhật trạng thái sang kích hoạt thành công",
        CHANGE_EMAIL_SUCCESS: "Thay đổi email thành công",
        NO_ADDRESS: "Chưa có thông tin, vui lòng thêm địa chỉ",
    },

    POST: {
        TITLE_MENU: "News & posts management",
        TITLE_LIST_VIEW: "List of news & posts",
        TITLE_CREATE_VIEW: "Create news & posts",
        TITLE_UPDATE_VIEW: "Update news & posts",
        TITLE_DETAIL_VIEW: "View news & posts detail",
        BASIC_INFO: "Basic information",

        BANNER: "Banner",
        TITLE: "Title",
        ENTER_TITLE: "Enter title",
        CATEGORY: "Category",
        SELECT_CATEGORY: "Select category",
        TYPE: "Type",
        SELECT_TYPE: "Select type",
        DESCRIPTION: "Description",
        ENTER_DESCRIPTION: "Enter description",
        EVENT_TIME: "Event time",
        SELECT_EVENT_TIME: "Select event time",
        HIGHLIGHTED: "Highlighted",
        CONTENT: "Content",

        LESSON_VIDEO_URL: "Video URL {0}",
        IS_HIGHTLIGHTED: "Highlight news/ events/ posts",

        VIDEO_NOTE: "Attached video (always placed at the end of posts)",
        PLEASE_ENTER_URL_VIDEO_FROM_YOUTUBE: "Please enter the URL of the video from YouTube",
        ADD_NEW_VIDEO_LINK: "Add new video link",
        PUBLISH_STATUS: "Publish status",
        PUBLISH: "Publish",
        STOP_PUBLISH: "Stop publish",
        SEND_NOTIFICATION: "Send notification",
        PUBLISH_POST: "Publish news & posts",
        UNPUBLISHING: "Unpublishing",
        UNPUBLISHED: "Unpublished",
        PUBLISH_READY: "Publish ready",
        NOT_PUBLISH_READY: "Not publish ready",
        PUBLISHING: "Publishing",
        PUBLISHED: "Published",
        UNKNOWN: "Unknown",

        CONFIRM_DELETE: "You definitely want to delete this news & posts",
        DELETE_SUCCESS: "News & posts successfully deleted",
        CREATE_SUCCESS: "Successfully created new news & posts",
        UPDATE_SUCCESS: "Update information news & post successfully",
        PUBLISH_SUCCESS: "Publish news & post successfully",
        STOP_PUBLISH_SUCCESS: "Stop publish news & post successfully",
    },

    CATEGORY: {
        TITLE_INFO: "Category information",
        COURSE: "Course",
        POST: "Post",
        QUESTION: "Question",
        TYPE: "Type",
        PARENT_CATEGORY: "Parent type",
        NAME: "Name",
        SELECT_TYPE: "Select type",
        SELECT_PARENT_CATEGORY: "Select parent category",
        ENTER_NAME: "Enter category name",
        ADD: "Add category",
        CREATE_SUCCESS: "New category created successfully",
        UPDATE_SUCCESS: "Updated category information successfully",
        CONFIRM_DELETE: "Are you sure you want to remove this category?",
        DELETE_SUCCESS: "Delete category successfully",
    },

    TAG: {
        TAG_INFO: "Tag information",
        TAG_NAME: "Tag name",
        ENTER_TAG_NAME: "Enter tag name",
        SHORT_NAME: "Short name",
        ENTER_SHORT_NAME: "Enter short name",
        TYPE_TAG: "Type tag",
        SELECT_TYPE_TAG: "Select type tag",
        DESCRIPTION: "Description",
        ENTER_DESCRIPTION: "Enter description",
        SEQUENCE: "Sequence",
        EXPERTISED: "Expertised",
        POST: "Post",
        COURSE: "Course",
        DUPLICATE_TAG_NAME: "Duplicate tag name",
        CONFIRM_DELETE: "Are you sure you want to remove this tag?",
        DELETE_SUCCESS: "Tag deleted successfully",
        CREATE_SUCCESS: "Created new tag successfully",
        UPDATE_SUCCESS: "Tag information updated successfully",
    },

    TOPIC: {
        TITLE_MENU: "Management topic",
        TITLE_LIST_VIEW: "List of topic",
        TITLE_CREATE_VIEW: "Create new topic",
        TITLE_UPDATE_VIEW: "Update a topic",
        TITLE_DETAIL_VIEW: "Detail of topic",

        BASIC_INFO: "Basic info",
        USER_NAME: "Tên người dùng",
        NAME: "Name",
        NAME_ALLOWED_CHARS: "Characters are allowed: a-z A-Z 0-9 - _ . ~ %",
        AVATAR: "Avatar",
        DESCRIPTION: "Descri ption",
        INPUT_NAME: "Input name",
        INPUT_DESCRIPTION: "Input description",

        LIST_OF_USER: "List of user",
        SUBSCRIBED: "Subscribed",
        UNSUBSCRIBED: "Unsubcribe",
        BLOCKED: "Blocked",

        STATUS: "Status",
        SEARCH_TEXT: "Search by topic name",

        TYPE: "Type",
        SELECT_TYPE: "Select type",
        CATEGORY: "Category",
        SELECT_CATEGORY: "Select category",
        UPDATE_SUCCESS: "Updated topic information successfully",
        CREATE_SUCCESS: "Created new topic successfully",
        CONFIRM_BLOCK: "Confirm block this user",
        BLOCK_SUCCESS: "Blocked user from your topic successfully",
        CONFIRM_DELETE: "Confirm delete this topic",
        DELETE_SUCCESS: "Deleted a topic successfully",

        TOPIC_NAME: "Chủ đề",
        SELECT_TOPIC: "Chọn chủ đề"
    },

    Validation: {
        TOPIC_NAME: "Wrong topic name format",
        EMAIL_ADDRESS: "Wrong email format",
        REQUIRED: "The data field is required",
        INVALID_FILE: "File is invalid",
        CANCEL_UPLOAD_IMAGE: "Are you sure to cancel uploading this image?",
        UPLOAD_IMAGE_FAILED: "Image upload failed",
    },

    COMMUNITY: {
        BASIC_INFO: "Basic info",
        APPEARANCE: "Appearance",
        TYPE: "Type",
        SELECT_TYPE: "Select type",
        NAME: "Name",
        INPUT_NAME: "Input name",
        IMAGE: "Image",
        DESCRIPTION: "Description",
        INPUT_DESCRIPTION: "Input description",
        PRIMARY_COLOR: "Primary color",
        PRIMARY_COLOR_DESC: "This color will be applied to the top bar and buttons in the community.",
        FONT: "Font",
        SELECT_FONT: "Select font",
        FONT_DESC: "This will be the primary font used for this community.",
        BANNER_IMAGE: "Banner image",
        PUBLISH_STATUS: "Publish status",
        CONFIRM_DELETE: "Confirm delete this community",
        CONFIRM_PUBLISH: "Confirm publish this community",
        CONFIRM_UNPUBLISH: "Confirm unpublish this community",
        DELETE_SUCCESS: "Deleted successfully",
        PUBLISH_SUCCESS: "Published successfully",
        UNBLISH_SUCCESS: "Unpublished successfully",
    },

    NOTIFICATION: {
        BASIC_INFO: "Notification information",
        TITLE: "title",
        ENTER_TITLE: "Enter title",
        CONTENT: "Content",
        ENTER_CONTENT: "Enter content",
        NOTIFICATION_TYPE: "Notification type",
        SELECT_NOTIFICATION_TYPE: "Select notification type",
        RECEIVER: "Receiver",
        SELECT_RECEIVER: "Select Receiver",
        GROUP_RECEIVER: "Recipient group",
        SELECT_GROUP_RECEIVER: "Select recipient group",
        READ: "Readed",
        UNREAD: "Unreaded",
        STATUS: "Status",
        SELECT_STATUS: "Select status",
        SEND_DATE: "Send date",
        SEND_TIME: "Send time",
        RECEIVED_DATE: "Received date",
        RECEIVED_TIME: "Received time",
        SELECT_SEND_DATE: "Select send date",
        SELECT_SEND_TIME: "Select send time",
        SEND_IMMEDIATELY: "Send immediately",
        SENT: "Sended",
        RECEIVED: "Received",
        FROM: "From",
        TO: "To",
        ENTER_TIME: "Select time",
        GROUP_CC: "Group Cc",
        GROUP_BCC: "Group Bcc",
        SELECT_GROUP: "Select group",
        USER_CC: "User Cc",
        USER_BCC: "User Bcc",
        SELECT_USER: "Select user",
        BY_MY_SELF: "",
        PENDING: "Pending",
        SENDING: "Sending",
        SUCCESS: "Send success",
        FAILURE: "Send failed",
        SEE_NOTIFICATION: "See notification",

        CREATE_SUCCESS: "Created notification successfully",
        UPDATE_SUCCESS: "Updated notification successfully",
        DELETE_SUCCESS: "Deleted notification successfully",
        CONFIRM_DELETE: "You definitely want to remove this notification",
        HAVE_NOT_ORGANIZATION_MESSAGE: "Please join the organization before creating an notification",
        REQUIRED_GROUP_RECEIVER_OR_RECEIVER: "Please select a recipient group or recipient to send the notification to!",
    },

    FAQ: {
        TITLE_MENU: "Quản lý câu hỏi",
        TITLE_LIST_VIEW: "Các câu hỏi thường gặp",
        TITLE_CREATE_VIEW: "Thêm mới câu hỏi",
        TITLE_UPDATE_VIEW: "Cập nhật thông tin câu hỏi",
        TITLE_DETAIL_VIEW: "Chi tiết thông tin câu hỏi",
        QUESTION: "Câu hỏi",
        ANSWER: "Trả lời",
        INPUT_QUESTION: "Nhập câu hỏi",
        INPUT_ANSWER: "Nhập câu trả lời",
        SEARCH_TEXT: "Tìm kiếm theo câu hỏi hoặc câu trả lời",
        INPUT_SEARCH_TEXT: "Nhập câu hỏi hoặc câu trả lời"
    },

    CHANNEL: {
        TITLE_MENU: "Channel",
        TITLE_LIST_VIEW: "List of channel",
        TITLE_CREATE_VIEW: "Create a new channel",
        TITLE_UPDATE_VIEW: "Update channel information",
        TITLE_DETAIL_VIEW: "Detailed channel information",
        CREATE_CHANNEL: "Create channel",
        FILE: "File",
        IMAGE: "Image",
        VIDEO: "Video",
        CHANNEL_NAME: "Channel name",
        CHANNEL_DESCRIPTION: "Description",
        ENTER_NAME: "Enter Name",

        CREATE_SUCCESS: "Create channel success",
        UPDATE_SUCCESS: "Update information of channel success",
        DELETE_SUCCESS: "Delete channel success",
        CONFIRM_DELETE: "You definitely want to delete this channel",
        CREATE_NEW_POST: "Create a new Post",
        UPDATE_POST: "Update Post information",
        CREATE_POST: "Create post",
        POST_IN_CHANNEL: "Post in channel",
        SELECT_CHANNEL: "Select channel",
        POST_TITLE: "Post title",
        ENTER_TITLE: "Enter title",
        POST_DESCRIPTION: "Post description",
        ENTER_DESCRIPTION: "Enter description",
        NOTE_TITLE: "Guide the conversation in this channel with a channel of your choice.",
        MAX_24_CHAR: "Max 24 characters...",
        NOTE_IMG: "Image will be displayed in the description card shown on the right.",
        IMG_169: "Recommended aspect radio 16:9",
        LINK_COURSE: "Link a course",
        CHANGE_LINK_COURSE: "Change link a course",
        ADD_NEW_LINK_COURSE: "Add new ink a course",
        NOTE_LINK_COURSE: "Select a course that student have access to, creating a more holistic, dynamic learning experience.",
        CHOOSE_LINK_COURSE: "Choose link course",
        UN_LINK_COURSE: "Unlink a course",
        TOTAL_MEMBER: "Total member",
        TOTAL_POST: "Total post",
        VIDEO_URL: "Video URL",
        ADD_VIDEO: "Add video",
        NOTE_VIDEO_URL: "Supported Platforms: YouTube, Vimeo, Loom",
        NOTE_IMAGE: "Maximum 100MB file size",
        INVALID_URL: "Invalid URL",

        CREATE_POST_IN_CHANNEL_SUCCESS: "Create post success",
        DELETE_POST_IN_CHANNEL_SUCCESS: "Delete post success",
        UPDATE_POST_IN_CHANNEL_SUCCESS: "Update information of post success",
        CONFIRM_DELETE_POST_IN_CHANNEL_SUCCESS: "You definitely want to delete this post?",

        FOLLOW: "Follow",
        UNFOLLOW: "Unfollow",
        PIN: "Pin",
        COMMENTS: "Comments",
        PAST_ACTIVITY: "Past activity",
        COMMUNITY_ROLE: "Community Role",
        WRITE_A_POST: "Write a post in channel",
        CONFIRM_JOIN_CHANNEL: "Sorry, you are not a member of this channel. Do you want to join this channel?",
    },

    MEMBER: {
        MEMBER: "Members",
        MEMBER_NAME: "Member name",
        INVITE_MEMBER: "Invite member",
        LIST_MEMBER: "List of members",
        SEARCH_TEXT: "Search by name member",
        INPUT_SEARCH_TEXT: "Enter member name",
        COMMUNITY_NAME: "Community name",
        SELECT_COMMUNITY: "Select community",
        INPUT_EMAIL: "Input email",
        ROLE_NAME: "Role name",
        SELECT_ROLE: "Select role",
        PLEASE_SELECT_CHANNEL: "Please select a channel",
        PLEASE_SELECT_COMMUNITY: "Please select a community",
        INVITE_TO_CHANNEL: "Invite member to channel",
        INVITE_TO_COMMUNITY: "Invite member to Community",
        INVITE_MEMBER_SUCCESS: "Invitation sent successfully",
    }

};

export default en;
